var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegisterBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 13H9C8.45 13 8 12.55 8 12H1.01V16C1.01 17.1 1.91 18 3.01 18H17C18.1 18 19 17.1 19 16V12H12C12 12.55 11.55 13 11 13ZM18 4H14C14 1.79 12.21 0 10 0C7.79 0 6 1.79 6 4H2C0.9 4 0 4.9 0 6V9C0 10.11 0.89 11 2 11H8V10C8 9.45 8.45 9 9 9H11C11.55 9 12 9.45 12 10V11H18C19.1 11 20 10.1 20 9V6C20 4.9 19.1 4 18 4ZM8 4C8 2.9 8.9 2 10 2C11.1 2 12 2.9 12 4H7.99H8Z",
    fill: "#383838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterBriefcase);
export default __webpack_public_path__ + "static/media/register_briefcase.6dfc451809970ad8583e209737e87b4e.svg";
export { ForwardRef as ReactComponent };